export enum AttendanceMessageDatasetType {
  COURSE_USER_ACTIVITY = "course-user-activity",
}

export type CourseUserActivityType = {
  courseId: string;
  pageId: string;
  userId: string;
  active: "0" | "1";
  following: "0" | "1";
};

export type BaseAttendanceMessage = {
  type: "attendance-update";
  datasetType: AttendanceMessageDatasetType;
  targetRole: "all" | "student" | "staff";
  targetOrgId?: string;
  error?: unknown;
};

export type UserActivityMessage = BaseAttendanceMessage &
  CourseUserActivityType & {
    datasetType: AttendanceMessageDatasetType.COURSE_USER_ACTIVITY;
    removed?: "0" | "1";
  };

export type AttendanceMessageType = UserActivityMessage;
